export const Actions = {
  SET_LD_STATE({ commit }, newState) {
    commit('SET_LD_STATE', newState);
  },

  RESIZE_GRID_ITEM({ commit, rootState }, payload) {
    const legendHeight = Math.ceil(payload.lh / rootState.dashboard.config.gridItemRowHeight);
    commit('RESIZE_GRID_ITEM', {
      h: payload.h,
      lh: legendHeight,
      i: payload.i,
      w: payload.w,
    });
  },

  async ADD_WIDGET({ commit }, payload) {
    commit('ADD_WIDGET', payload);
  },

  async MOVE_WIDGET({ commit }, payload) {
    commit('MOVE_WIDGET', payload);
  },

  async REMOVE_WIDGET({ commit }, payload) {
    commit('REMOVE_WIDGET', payload);
  },

  async INIT_LAYOUT({ commit }) {
    const layout = window.localStorage.getItem('dashboardLayout');
    if (layout) {
      commit('INIT_LAYOUT', layout);
    }
  },
};
